export enum NativeEmbedCommandType {
	FreezeFrameRequest = 'freezeFrameRequest',
	UnfreezeFrame = 'unfreezeFrame',
}

export enum NativeEmbedChildCommandType {
	FreezeFrameResponse = 'freezeFrameResponse',
	UnfreezeFrameResponse = 'unfreezeFrameResponse',
}
